module.exports = {
      id: "paywalliconbenefittwo-usage",
      viewBox: "0 0 34.667 27.156",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#paywalliconbenefittwo",
      toString: function () {
        return this.url;
      }
    }